import React, { useEffect } from 'react';
import { Switch, Route } from 'react-router-dom';

import { RegisterLoc } from '../loc/register';
import { loc } from '../lib/loc';
import { useStores } from '../hooks/use-stores';

import LegalRegister from '../components/Registration/LegalRegister';
import PersonalRegister from './RegisterScreens/PrivateRegister';
import SwitchRegister from './RegisterScreens/SwitchRegister';
import CompleteRegister from './RegisterScreens/CompleteRegister';
import Header from '../components/Header';
import NotFound from '../interface/NotFound';

export default function Register() {
    const { HeaderStore: store } = useStores();
    const { setTitle } = store || {};
    window.scrollTo(0, 100);

    useEffect(() => {
        setTitle(loc(RegisterLoc.pageTitle));
    }, [setTitle]);

    return (
        <>
            <Header />
            <div className="wrap-page-content">
                <Switch>
                    <Route path="/register/legal/" component={LegalRegister} />
                    <Route path="/register/personal" component={PersonalRegister} />
                    <Route path="/register/complete" component={CompleteRegister} />
                    <Route exact path="/register" component={SwitchRegister} />

                    <Route
                        render={() => (
                            <NotFound
                                button={{
                                    to: '/register/',
                                    title: loc(RegisterLoc.__mainPageButton),
                                }}
                            />
                        )}
                    />
                </Switch>
            </div>
        </>
    );
}
